import React from "react"
import { NavLink } from "react-router-dom"

const NAVY = "#221C5D"

const TABS = [
  { to: "/admin/announcements", label: "Duyurular", icon: "bx-broadcast" },
  { to: "/admin/announcements/push", label: "Push Bildirimleri", icon: "bx-mobile-alt" },
]

const styles = `
  .announcement-tabs { display: flex; gap: .4rem; flex-wrap: wrap; margin-bottom: 1rem; }
  .announcement-tabs .ann-tab {
    display: inline-flex; align-items: center; gap: .35rem;
    padding: .4rem .95rem; border-radius: 999px;
    border: 1px solid ${NAVY}; color: ${NAVY}; background: #fff;
    font-size: .875rem; font-weight: 500; text-decoration: none;
    transition: background .15s, color .15s;
  }
  .announcement-tabs .ann-tab:hover { background: ${NAVY}12; }
  .announcement-tabs .ann-tab.active { background: ${NAVY}; color: #fff; }
`

const AnnouncementTabs = () => (
  <nav className="announcement-tabs" aria-label="Duyuru sekmeleri">
    <style>{styles}</style>
    {TABS.map((t) => (
      <NavLink key={t.to} to={t.to} end className="ann-tab">
        <i className={`bx ${t.icon}`} />{t.label}
      </NavLink>
    ))}
  </nav>
)

export default AnnouncementTabs
